;(async function quoteHandler() {
  const form = document.querySelector("#quote-form");
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const submitButton = document.querySelector('#quote-form button');
    submitButton.setAttribute('disabled', 'true');
    const fields = e.target.elements;
    const errs = _handleErrors(fields);
    if(errs.length === 0) {
      const payload = {
        locationId: fields.namedItem("location_id").value ?? null,
        lineItems: fields.namedItem("line_items").value,
        comment: fields.namedItem("comment").value,
        customer: {
          id: fields.namedItem("customer_id").value ?? null,
          email: fields.namedItem("email").value,
          name: fields.namedItem("name").value,
          phone: fields.namedItem("phone").value,
          zoneCode: fields.namedItem("zoneCode").value,
          role: fields.namedItem("role").value,
        },
      }
      const response = await _postToAPI(payload);
      const data = await response.json();
      console.log(data);
      console.log(response);
      if(data.status === 'success' || response.status === 200) {
        const form = document.querySelector('#quote-form');
        form.innerHTML = '<p>Thank you. We will contact you once we have reviewed your request.</p>';
      }
    }
  });

  function _handleErrors(fields) {
    const errDiv = document.querySelector('.errors');
    const requiredFields = [
      {name: 'email', message: 'Please provide an email address'},
      {name: 'name', message: 'Please provide your full name'},
    ]

    const errors = requiredFields.reduce((acc, curr) => {
      if(fields[curr.name] === '') acc.push(curr);
      return acc;
    }, [])
    
    if(errors.length > 0) {
      errDiv.innerHTML = 'Please provide: <br />' + errs.map(e => e.message).join('<br />')
      const erroredInputs = document.querySelectorAll(errs.map(e => '.' + e.name).join(' '))
      erroredInputs.forEach(ele => ele.classList.add('errored'))
    }
    return errors;
  }

  async function _postToAPI(payload) {
    return await fetch('https://salesmin.changecompanies.net/tcc-bi/shopify/request_quote', {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer doo95949jh94848341d73500ae8cbdb5ef8d4b4175399',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
  }
})();
